export type ParsedFullName = {
	nombre: string;
	first_name: string;
	second_name?: string;
	apellido_paterno: string;
	apellido_materno: string;
};

export const parseFullName = (input: string): ParsedFullName | null => {
	const words = input
		.trim()
		.split(/\s+/)
		.filter((word) => word.length > 0);

	if (words.length < 3) return null;

	if (words.length === 3) {
		const [first_name, apellido_paterno, apellido_materno] = words;
		return {
			nombre: first_name,
			first_name,
			apellido_paterno,
			apellido_materno,
		};
	}

	const apellido_materno = words[words.length - 1];
	const apellido_paterno = words[words.length - 2];
	const givenNames = words.slice(0, words.length - 2);
	const first_name = givenNames[0];
	const second_name =
		givenNames.length > 1 ? givenNames.slice(1).join(' ') : undefined;

	return {
		nombre: givenNames.join(' '),
		first_name,
		second_name,
		apellido_paterno,
		apellido_materno,
	};
};

export const buildFullName = (parts: {
	first_name?: string;
	second_name?: string;
	nombre?: string;
	apellido_paterno?: string;
	apellido_materno?: string;
}): string =>
	[
		parts.first_name ?? parts.nombre,
		parts.second_name,
		parts.apellido_paterno,
		parts.apellido_materno,
	]
		.filter((part): part is string => Boolean(part && part.trim().length > 0))
		.join(' ')
		.trim();
